import HeaderBar from '@/components/common/Header.vue';
import { getMeetOrderInfo, getExerciseOrderInfo } from '@/api/meeting';
import { getWechatQe } from '@/api/api';
import { defineComponent, ref } from 'vue';
import AppTopBar from '@/components/common/AppTopBar.vue';
import { appPort, getUserId, imagePreview, jumpModuleApp, prevPageView, appFullScreen, pxToRem, getAppBarHeight, openWXPage, versionCompare } from '@/widget/index';
import { getOrderStatus } from '@/api/pay';
import { Toast } from 'vant';
export default defineComponent({
    data() {
        return {
            orderInfo: {},
            img: '',
            tipMsg: '打开【好医术】APP进入练习页面',
            isApp: appPort(),
            module: this.$route.params.module
        };
    },
    setup() {
        let barH = getAppBarHeight();
        const barHeight = ref(0);
        if (appPort()) {
            barHeight.value = pxToRem(barH);
            appFullScreen();
        }
        return {
            barHeight
        };
    },
    computed: {
        orderStatus() {
            if (this.orderInfo.payStatusText === '已支付' ||
                (this.orderInfo.orderStatus !== 0 && this.orderInfo.orderStatus) ||
                this.orderInfo.orderType === 2 ||
                this.orderInfo.isPay) {
                return true;
            }
            return false;
        },
        showBtn() {
            // 展示添加客服按钮
            return this.isApp && versionCompare('8.3.6');
        }
    },
    methods: {
        backFn() {
            if (this.isApp) {
                prevPageView();
                return;
            }
            if (this.orderStatus) {
                this.$router.replace({
                    path: this.getBackUrl()
                });
            }
            else {
                this.$router.replace({
                    path: '/course'
                });
            }
        },
        getBackUrl() {
            const num = this.orderInfo.meetingType;
            if (num === 2 || num === 3 || num == 1) {
                return `/courseguide/train/${this.orderInfo.meetingId}`;
            }
            else if (this.$route.params.module === 'omocard') {
                return '/course/omo';
            }
            else {
                return `/list/exercise`;
            }
        },
        getOrderInfo() {
            const orderId = this.$route.params.orderId;
            if (/^[ZN]/i.test(orderId)) {
                // 智能练习订单
                this.exerciseOrder(orderId);
            }
            if (this.module == 'vip') {
                // 会员订单
                this.orderMsg(orderId);
            }
            else {
                // OMO 线上训练营订单(不同 module 类型的订单)
                this.meetingOrder(orderId);
            }
        },
        meetingOrder(orderId) {
            getMeetOrderInfo({
                userId: getUserId(),
                orderId: orderId,
                module: this.module
            }).then(res => {
                if (res.code === 200) {
                    this.orderInfo = res.data;
                    if (!this.orderStatus) {
                        // 订单未支付进入订单支付页
                        this.$router.replace({
                            name: 'orderDetail',
                            params: {
                                module: this.module,
                                orderId: orderId
                            }
                        });
                    }
                    else {
                        this.getWechatQ({
                            module: this.module,
                            id: this.orderInfo.meetingId
                        });
                    }
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        orderMsg(orderId) {
            // 获取订单信息
            getOrderStatus(this.module, orderId).then((res) => {
                if (res.code == 200) {
                    this.orderInfo = res.data;
                    if (this.orderInfo.isPay) {
                        this.getWechatQ({
                            module: this.module,
                            id: this.orderInfo.vipId
                        });
                    }
                    else {
                        // 未支付
                        if (this.isApp) {
                            prevPageView();
                        }
                        else {
                            history.go(-1);
                        }
                    }
                }
            });
        },
        exerciseOrder(orderId) {
            getExerciseOrderInfo({
                orderId: orderId
            }).then(res => {
                this.$hideLoading();
                if (res.code === 200) {
                    this.orderInfo = res.data;
                    if (this.orderInfo.orderStatus === 0) {
                        this.$router.replace({
                            name: 'guideExercise'
                        });
                    }
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        getWechatQ(params) {
            // 获取微信二维码
            getWechatQe(params).then(res => {
                if (res.code === 200) {
                    this.img = res.data.wechtCodeImgName;
                    if (!this.img) {
                        this.img = `https://img-a.haoyishu.com/images/activity/service/qrcode${this.orderInfo.depId || 1}.png`;
                    }
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        toExercise() {
            if (this.isApp) {
                jumpModuleApp({
                    typeId: 'exercise_home',
                    dataId: 0,
                    tab: this.orderInfo.meetingType === 3 ? 'TEAM' : 'OMO'
                });
            }
        },
        imgPreview(url) {
            imagePreview({ typeId: 'image_preview', images: [url], posIndex: 1 });
        },
        addServe() {
            if (!versionCompare('8.3.6')) {
                Toast('APP版本太低，请更新APP后再试');
                return;
            }
            // 添加学服
            let id = 0;
            if (this.module == 'meeting') {
                id = this.orderInfo.meetingId;
            }
            else {
                id = this.orderInfo.vipId;
            }
            openWXPage(`/pages/judge/index?page=serve&type=${this.module}&id=${id}`);
        }
    },
    mounted() {
        if (this.isApp) {
            this.tipMsg = '去练习';
        }
        this.getOrderInfo();
    },
    components: {
        HeaderBar,
        AppTopBar
    }
});
